<template>
    <v-container ma-0>
        <ApolloQuery
                class="fill-height"
                client-id="clientPrivate"
                :query="require('../graphql/queries/station.gql')"
                :variables="{ id: $route.params.sgid }">
            <template v-slot="{ result: { error, data }, isLoading }">

                <v-layout v-if="isLoading" class="loading" row wrap align-center
                          justify-center fill-height>
                    <v-flex shrink>
                        <v-progress-circular
                                :size="70"
                                :width="1"
                                height="15"
                                indeterminate
                                color="blueprimary"
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>

                <v-layout v-else-if="data && data.station" row wrap fill-height
                          align-content-space-between>

                    <v-flex class="data-group">
                        <v-layout row wrap>
                            <v-flex pt-3 xs12 class="station-name">
                                {{data.station.name | uppercase}} ({{$vuetify.t(`$vuetify.generic.station_statues.${$options.filters.lowercase(data.station.state)}`)}})
                            </v-flex>
                            <v-flex pb-3 xs12 class="station-address">
                                {{data.station.address | uppercase}}
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="station-info" align-start>
                            <v-flex v-for="bay in data.station.bays.nodes"
                                    :key="bay.id" xs12 pa-2>
                                <v-card>
                                    <v-card-title primary-title class="pb-0">
                                        <v-flex class="station-label" xs12>
                                            {{$vuetify.t("$vuetify.Station.position")|uppercase}} {{bay.position}}
                                            <span class="usage">
                                                {{$_getUsageTranslation(bay.use)}}
                                            </span> -
                                            <span class="bay-state" :class="bay.state | lowercase">
                                                {{$vuetify.t(`$vuetify.generic.bay_statues.${bay.state}`)}}
                                            </span>
                                        </v-flex>
                                        <v-flex v-if="bay.state === 'READY'" class="station-bay-usage" xs12>
                                         {{ $_getUsageStateMessage(bay.usageState)}}
                                        </v-flex>
                                    </v-card-title>
                                    <bay-usage
                                            :bay="bay"
                                            :url-icon-bay-type="getIconBayType(bay.bayType.id)"
                                            :icon-car="iconCar"
                                            :icon-charge="iconCharge"
                                            :icon-charging="iconCharging"
                                            :icon-fault-error="iconFaultError"
                                            :icon-full-charge="iconFullCharge"
                                            :icon-not-eletric="iconNotEletric"
                                            :icon-out-of-service="iconOutOfService"
                                            :icon-private="iconPrivate"
                                            :icon-sharing="iconSharing"
                                            :icon-ndf="iconNdf">
                                    </bay-usage>
                                </v-card>
                            </v-flex>

                        </v-layout>

                    </v-flex>
                    <v-flex class="button-bar">
                        <v-layout mt-3>
                            <v-flex xs12>
                                <v-btn color="button-dark"
                                       class="button-pickup"
                                       :class="{ disabled: data.station.state !== 'READY'}"
                                       :disabled="data.station.state !== 'READY'"
                                       @click="enableLogin= true">
                                    {{$vuetify.t("$vuetify.Station.loginToStation")|uppercase}}
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <station-login @disable="enableLogin=false"
                                   :enable="enableLogin"
                                   v-if="enableLogin"
                                   :station="data.station">
                    </station-login>
                </v-layout>


                <v-layout v-else class="noresult" row wrap align-center
                          justify-center fill-height>
                    <v-flex shrink>
                        {{$vuetify.t("$vuetify.PopUpStation.noResult")}}
                    </v-flex>
                </v-layout>
            </template>
        </ApolloQuery>


    </v-container>


</template>


<script>

    import StationLogin from "../components/StationLogin"
    import iconSharing from '../assets/icon_sharing.png'
    import iconPrivate from '../assets/icon_privata.png'
    import iconCar from '../assets/icon_auto.png'
    import iconCharge from '../assets/icon_ricarica.png'
    import iconFullCharge from '../assets/icon_carica.png'
    import iconFaultError from '../assets/icon_fault_error.png'
    import iconOutOfService from '../assets/icon_fuori_servizio.png'
    import iconCharging from '../assets/icon_in_carica.png'
    import iconNotEletric from '../assets/icon_non_elettrico.png'
    import iconNdf from '../assets/icon_ndf.png'
    import {getBayTypeIconUrl} from '../helpers/location'
    import BayUsage from "../components/BayUsage";


    export default {
        name: 'Station',
        data: function () {
            return {
                enableLogin: false,
                iconSharing,
                iconPrivate,
                iconCar,
                iconCharge,
                iconFullCharge,
                iconFaultError,
                iconOutOfService,
                iconCharging,
                iconNotEletric,
                iconNdf,
                existsIconBayType: false
            }
        },
        methods: {
            getIconBayType(id){

                return getBayTypeIconUrl(id)
            },
            $_getUsageTranslation(usages){
                let toReturn = []
                usages.forEach((use)=>{
                    toReturn.push(this.$vuetify.t(`$vuetify.generic.bay_uses.${use}`))
                })
                return toReturn.join(", ")
            },
            $_getUsageStateMessage(usageStates){

                if (usageStates.includes("NONE")) {
                    return this.$vuetify.t("$vuetify.Station.bayUsageBusyState")
                }

                let toReturn = []
                usageStates.forEach((use)=>{
                    toReturn.push(this.$vuetify.t(`$vuetify.generic.bay_usage_states.${use}`))
                })
                return this.$vuetify.t("$vuetify.Station.availableFor") + toReturn.join(", ")
            }


        },
        components: {
            BayUsage,
            StationLogin
        }

    }
</script>


<style lang="scss" scoped>

    .data-group {
        height: calc(100% - 65px);

        .station-name {
            font-weight: bold;

        }

        .station-info {
            font-weight: normal;
            height: calc(100% - 73px);
            overflow-x: hidden;
            overflow-y: auto;

            .station-bay-usage{
                text-align: left;
            }

            .station-label {
                text-align: left;
                font-weight: bold;

                .usage{
                    font-weight: normal;
                    text-transform: uppercase;
                }

                .bay-state {
                    font-weight: normal;
                    text-transform: lowercase;

                    &.out_of_service, &.faulty {
                        color: var(--v-error-base);
                    }

                    &.ready {
                        color: var(--v-success-base);
                    }

                }
            }




            & /deep/ .v-list__tile__content {
                font-weight: normal !important;
            }
        }
    }

    .button-bar {
        height: 65px;

        .button-pickup {
            color: var(--v-primary-base)
        }

    }


</style>